import Axios from 'middleware/axiosInstance'
import React, { useEffect, useState } from 'react'
import { Button, Space, Table, message, Card, Typography } from "antd";
import { useNavigate } from 'react-router-dom';
import Loading from 'layouts/Loading/Loading';
import './SocialMediaSorting.scss';

const { Title, Text } = Typography;

const SocialMediaSorting = () => {
    const navigate = useNavigate();

    const [allSocialMedia, setAllSocialMedia] = useState([]);
    const [hasOrderChanged, setHasOrderChanged] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const getAllSocialMedia = () => {
        Axios.get("/social-media")
            .then((res) => {
                setAllSocialMedia(res.data || []);
            })
            .catch(err => {
                console.log(err);
                message.error('خطا در بارگذاری لیست شبکه‌های اجتماعی');
            });
    };

    useEffect(() => {
        getAllSocialMedia();
    }, []);

    // Handle drag and drop with HTML5 API
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('text/plain', index);
        e.target.style.opacity = '0.5';
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e, dropIndex) => {
        e.preventDefault();
        const dragIndex = parseInt(e.dataTransfer.getData('text/plain'));
        
        if (dragIndex !== dropIndex) {
            const newSocialMedia = [...allSocialMedia];
            const [draggedItem] = newSocialMedia.splice(dragIndex, 1);
            newSocialMedia.splice(dropIndex, 0, draggedItem);
            
            setAllSocialMedia(newSocialMedia);
            setHasOrderChanged(true);
        }
        
        e.target.style.opacity = '1';
    };

    const handleDragEnd = (e) => {
        e.target.style.opacity = '1';
    };

    // Submit new order to backend
    const submitNewOrder = async () => {
        if (!hasOrderChanged) {
            message.info('ترتیب تغییر نکرده است');
            return;
        }

        setIsSubmitting(true);
        try {
            const orderData = allSocialMedia.map((socialMedia, index) => ({
                id: socialMedia.id,
                order: index
            }));

            const response = await Axios.post('/social-media/reorder', orderData);
            
            if (response.status === 200) {
                message.success('ترتیب با موفقیت ذخیره شد');
                setHasOrderChanged(false);
            }
        } catch (error) {
            console.error('Error updating order:', error);
            message.error('خطا در ذخیره ترتیب');
        } finally {
            setIsSubmitting(false);
        }
    };

    const columns = [
        {
            title: "ترتیب",
            dataIndex: "order",
            key: "order",
            width: 80,
            render: (_, record, index) => (
                <div className="order-number">
                    {index + 1}
                </div>
            ),
        },
        {
            title: "نام",
            dataIndex: "name",
            key: "name",
            sorter: (a, b) =>
                a.name > b.name ? 1 : b.name > a.name ? -1 : 0,
            ellipsis: true,
        },
        {
            title: "آدرس",
            dataIndex: "address",
            key: "address",
            ellipsis: true,
            render: (text) => (
                <a href={text} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff' }}>
                    {text}
                </a>
            ),
        },
    ];

    return (
        <div className="customized-container social-media-sorting-page">
            <div className="customized-wrapper">
                <Card>
                    <div className="page-header">
                        <Title level={3}>مرتب‌سازی شبکه‌های اجتماعی</Title>
                        <Text type="secondary">
                            برای تغییر ترتیب شبکه‌های اجتماعی، روی هر ردیف کلیک کرده و آن را به موقعیت جدید بکشید
                        </Text>
                    </div>

                    <div className="action-buttons">
                        <Space>
                            <Button 
                                type="primary" 
                                onClick={submitNewOrder}
                                loading={isSubmitting}
                                disabled={!hasOrderChanged}
                            >
                                ذخیره ترتیب جدید
                            </Button>
                            <Button 
                                onClick={() => {
                                    setHasOrderChanged(false);
                                    getAllSocialMedia();
                                }}
                            >
                                بازنشانی
                            </Button>
                            <Button 
                                type="default" 
                                onClick={() => navigate('/social-media')}
                            >
                                بازگشت به لیست شبکه‌های اجتماعی
                            </Button>
                        </Space>
                    </div>

                    {/* Info */}
                    {hasOrderChanged && (
                        <div className="info-alert">
                            <Text type="success">
                                ⚠️ ترتیب تغییر کرده است. برای ذخیره تغییرات روی "ذخیره ترتیب جدید" کلیک کنید.
                            </Text>
                        </div>
                    )}

                    {allSocialMedia.length > 0 ? (
                        <div className="sorting-table">
                            <Table
                                pagination={false}
                                columns={columns}
                                dataSource={allSocialMedia}
                                rowKey="id"
                                onRow={(record, index) => ({
                                    draggable: true,
                                    onDragStart: (e) => handleDragStart(e, index),
                                    onDragOver: (e) => handleDragOver(e),
                                    onDrop: (e) => handleDrop(e, index),
                                    onDragEnd: handleDragEnd,
                                    style: { cursor: 'grab' },
                                    className: 'draggable-row',
                                })}
                            />
                        </div>
                    ) : (
                        <div className="loading-container">
                            <Loading />
                        </div>
                    )}
                </Card>
            </div>
        </div>
    );
};

export default SocialMediaSorting;

